import collectedOptions from '../config/collectedOptions';
import { getStore } from '../store/store';
import { computed } from 'mobx';
var currentCategory = computed(function () {
    for (var categoryIndex = 0; categoryIndex < collectedOptions().length; categoryIndex++) {
        var currentCategory_1 = collectedOptions()[categoryIndex];
        if (currentCategory_1.key == getStore().currentCategoryKey) {
            return currentCategory_1;
        }
    }
    return null;
});
export default (function () { return currentCategory.get(); });
//# sourceMappingURL=getCurrentCategory.js.map